import React from "react";
import { QrCode, MousePointerClick, Lock, Zap, Smartphone, GitBranch } from "lucide-react";
import Beam from "../illustrations/Beam";

export default function Features() {
  const items = [
    { title: "QR Payments", desc: "Generate QR codes with amount and wallet address pre-filled.", Icon: QrCode },
    { title: "Privacy First", desc: "No personal information, subscriptions, or user data required.", Icon: Lock },
    { title: "Open Source", desc: "Payme.sol Basic is open-source to ensure transparency and build trust.", Icon: GitBranch },
    { title: "User Friendly", desc: "Minimal wallet permissions; no custody of your funds.", Icon: MousePointerClick },
    { title: "Fast", desc: "Built on Solana for near‑instant confirmations.", Icon: Zap },
    { title: "Mobile‑first", desc: "Optimized for phones and tablets used at the counter.", Icon: Smartphone },
  ];
  return (
    <section id="features" className="relative overflow-hidden" data-reveal>
      <div className="mx-auto max-w-6xl px-4 py-16 relative">
        <h2 className="mb-8 text-center text-3xl font-semibold">Features</h2>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">
          {items.map(({ title, desc, Icon }, idx) => (
            <div
              key={title}
              data-reveal
              style={{ ['--reveal-delay' as any]: `${idx * 100}ms` }}
              className="group relative overflow-hidden rounded-xl border border-neutral-700 bg-neutral-900/40 p-6 text-center transition-all duration-300 hover:border-indigo-500/50 hover:bg-indigo-500/5 hover:shadow-[0_0_40px_rgba(99,102,241,0.15)] hover:-translate-y-0.5"
            >
              <div className="relative mb-3 mx-auto inline-flex items-center justify-center rounded-md bg-indigo-600/15 p-2">
                <Beam tone="brandLight" className="absolute inset-0 -z-10" />
                <Icon className="size-5 text-indigo-400" />
              </div>
              <h3 className="text-lg font-semibold text-white">{title}</h3>
              <p className="mt-2 text-neutral-300">{desc}</p>
              <span className="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full bg-indigo-600/10 blur-2xl transition-all duration-300 group-hover:scale-110" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
